export const GET_FLOORS_STARTED = "GET_FLOORS_STARTED";
export const GET_FLOORS_SUCCESS = "GET_FLOORS_SUCCESS";
export const GET_FLOORS_FAILED = "GET_FLOORS_FAILED";
